import React, { useState } from 'react';
import { adjustInventoryItemQuantity } from 'services';
import { showError, showSuccess } from 'utils';
import styles from './index.module.scss';

const AdjustInventoryItemQuantityModal = props => {
  const [quantity, setQuantity] = useState<string>('');
  const [reason, setReason] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const { itemId, itemQuantity, onSuccess, toggleModal } = props;

  const adjustInventoryItemQuantityFn = async (e: React.FormEvent<EventTarget>) => {
    e.preventDefault();
    setLoading(true);
    try {
      await adjustInventoryItemQuantity(itemId, parseInt(quantity), reason);
      await onSuccess();
      showSuccess('Received quantity updated successfully.');
      toggleModal();
    } catch (e) {
      showError(e);
      setLoading(false);
    }
  };

  return (
    <div className={styles['main-container']}>
      <div className={styles['modal-container']}>
        <div className={styles['modal-header']}>
          <div>
            <div className={styles['label']}>Inventory Item</div>
            <div className={styles['modal-title']}>Adjust Inventory Item Quantity</div>
          </div>
          <i className={'fa fa-times'} onClick={toggleModal} />
        </div>
        <div className={styles['modal-body']}>
          <div className={styles['input-group']}>
            <div className={styles['label']}>Item Quantity</div>
            <input
              type={'number'}
              value={quantity || itemQuantity}
              className={'form-control'}
              onChange={e => setQuantity(e.target.value)}
            />
          </div>
          <div>
            <div className={styles['label']}>Reason</div>
            <input
              value={reason}
              className={'form-control'}
              onChange={e => setReason(e.target.value)}
            />
          </div>
        </div>
        <div className={styles['modal-footer']}>
          <button
            className={styles['cancel-button']}
            onClick={toggleModal}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            onClick={adjustInventoryItemQuantityFn}
            className={styles['submit-button']}
            disabled={loading}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdjustInventoryItemQuantityModal;
